import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class ImportInflationForecastResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: []
        }
    }
}
